<div class="theme-default">
    @if (!loading) {
        @if (isConnected && config) {
            <i-navbar [config]="config" (disconnect)="logout()">
                <router-outlet></router-outlet>
            </i-navbar>
        } @else {
            <router-outlet></router-outlet>
        }
    } @else {
        <div class="loader-full">
            <i-loader [styleClass]="'full'"></i-loader>
        </div>
    }

    <p-toast [key]="'ivalve-toast'" [position]="'bottom-right'"/>
</div>